import {RefObject} from "react";

/**
 * This is an interface used to provide a structure for a list of panels to be passed to a navigation card
 */
export interface FormNavigation {
  label: string;
  panelReference: RefObject<HTMLDivElement>;
}

/**
 * This method gives the form content area the ability to auto scroll the form to the relevant panel
 * @param parentContainer The reference to the parent container
 * @param targetPanel The reference to the relevant panel
 */
export function scrollToPanel(parentContainer: RefObject<HTMLDivElement | HTMLFormElement>, targetPanel: RefObject<HTMLDivElement>) {
  // Compute the values needed for the scrolling coordinate calculation
  const formAreaCoordinate = parentContainer.current?.getBoundingClientRect().top || 0;
  const desiredPanelCoordinate = targetPanel.current?.getBoundingClientRect().top || 0;
  const topValue = parentContainer.current?.scrollTop || 0;

  // Offset the top with the top of the relevant containers
  const scrollTop = topValue + (desiredPanelCoordinate - formAreaCoordinate);

  parentContainer.current?.scrollTo({
    top: scrollTop,
    behavior: "smooth"
  });
}